import {ADD_TO_CART, CART_UPDATED, CLEAR_CART, GET_CART, REMOVE_FROM_CART} from "./actionTypes";

export const addToCart = (product, invest) => {
    return {
        type: ADD_TO_CART,
        payload: {product, invest}
    };
};

export const removeFromCart = product => {
    return {
        type: REMOVE_FROM_CART,
        payload: {product}
    };
};

export const clearCart = () => {
    return {
        type: CLEAR_CART,
        payload: {}
    };
};

export const cartUpdated = cart => {
    return {
        type: CART_UPDATED,
        payload: cart
    };
};

export const getCart = () => {
    return {
        type: GET_CART,
        payload: {}
    };
};